<div *ngIf="!isEdited" class="cell-view">
  <div class="inner-view">{{ rowData[fieldName] }}</div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="StringCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="StringCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <app-string-input
    [control]="newValue"
    (onEnter)="onKeyupEnter()"
    (onEscape)="abortCellEdit()"
    (onClickOutside)="abortCellEdit()"
    inputClass="w-full mr-2"
    jmlAutoFocus
  >
    <button
      pButton
      type="button"
      [id]="fieldName + '§' + rowData['id']"
      icon="pi pi-check"
      [disabled]="!newValue?.valid || (mandatory && !newValue?.value)"
      (click)="onKeyupEnter()"
    ></button>
  </app-string-input>
</ng-template>
